"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _imageState = _interopRequireDefault(require("../image-state"));
require("./image-fade.css");
var _excluded = ["alt", "src"],
  _excluded2 = ["className", "fallbackClassName", "height", "imageOnlyClassName", "imageWhenHiddenClassName", "includeFallbackEnabled", "onError", "onLoad", "placeholder", "src", "style", "wrapperClassName"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var FallbackFader = function FallbackFader(_ref) {
  var className = _ref.className,
    completed = _ref.completed,
    fallbackClassName = _ref.fallbackClassName,
    placeholder = _ref.placeholder;
  var placeholderAlt = placeholder.alt,
    placeholderSrc = placeholder.src,
    otherPlaceholderProps = _objectWithoutProperties(placeholder, _excluded);
  var fallbackShowClass = placeholderSrc ? 'sb-imageFade__show' : 'sb-imageFade__fallbackShow';
  var fallbackClass = (0, _classnames["default"])(className, fallbackClassName, 'sb-imageFade__fallback', _defineProperty(_defineProperty({}, fallbackShowClass, !completed), 'sb-imageFade__hideForFade', completed));
  return placeholderSrc ? /*#__PURE__*/_react["default"].createElement("img", _extends({
    alt: placeholderAlt,
    className: fallbackClass,
    src: placeholderSrc
  }, otherPlaceholderProps)) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "sb-imageFade__fallbackDiv ".concat(fallbackClass)
  });
};

/**
 * `ImageFade` utilizes `ImageState` to determine if an image has loaded yet,
 * and how to make the experience as good as possible for the user while
 * they're waiting for their image to load (or if the image is broken).
 *
 * So that the fallback and true image can fade nicely into each other,
 * they both must remain absolutely positioned over one another. To compensate,
 * they are wrapped with a div that always has a position of relative.
 */

var ImageFade = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
    fallbackClassName = props.fallbackClassName,
    height = props.height,
    imageOnlyClassName = props.imageOnlyClassName,
    imageWhenHiddenClassName = props.imageWhenHiddenClassName,
    includeFallbackEnabled = props.includeFallbackEnabled,
    onError = props.onError,
    onLoad = props.onLoad,
    placeholder = props.placeholder,
    src = props.src,
    style = props.style,
    wrapperClassName = props.wrapperClassName,
    otherProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_imageState["default"], {
    onComplete: onLoad,
    onError: onError,
    src: src
  }, function (_ref2) {
    var completed = _ref2.completed,
      source = _ref2.source;
    var imageClassName = (0, _classnames["default"])(className, imageOnlyClassName, _defineProperty({
      'sb-imageFade__imagePositioning': includeFallbackEnabled,
      'sb-imageFade__show': completed,
      'sb-imageFade__hideForFade': !completed
    }, imageWhenHiddenClassName, !completed && imageWhenHiddenClassName));
    var wrapperStyle = (0, _classnames["default"])('relative height-100', wrapperClassName);

    // if consumer gave us a height, we assume they know what they are doing
    // and provide a maxHeight since the height attribute will likely we overridden
    // by global CSS height:auto
    var imgStyle = height ? _objectSpread({
      maxHeight: "".concat(parseInt(height), "px")
    }, style) : style;
    var imgProps = _objectSpread({
      className: imageClassName,
      src: source,
      style: imgStyle
    }, otherProps);
    return includeFallbackEnabled ? /*#__PURE__*/_react["default"].createElement("div", {
      className: wrapperStyle,
      ref: ref
    }, /*#__PURE__*/_react["default"].createElement("img", imgProps), /*#__PURE__*/_react["default"].createElement(FallbackFader, {
      className: className,
      completed: completed,
      fallbackClassName: fallbackClassName,
      placeholder: placeholder
    })) : /*#__PURE__*/_react["default"].createElement("img", _extends({
      ref: ref
    }, imgProps));
  });
});
ImageFade.displayName = 'ImageFade';
var _default = exports["default"] = ImageFade;